module.exports = __webpack_public_path__ + "static/media/instagram.ecf93964.svg";